module.exports = __webpack_public_path__ + "img/ResumeTemp1.08469593.png";